// ---------------------------------------------------------------------------
// QR เติมเงิน ผ่าน PaymentBroker (เหมือน LevelUpCRM paymentService)
// mock: สร้าง QR จำลอง (SVG) และถือว่าจ่ายสำเร็จเมื่อกด "จำลองจ่ายสำเร็จ" ในโมดัล — ไม่ยิงเน็ต
// ---------------------------------------------------------------------------
import { ENDPOINTS, PARTNER, PROCESS_TYPE, ORDER_TYPE, IS_MOCK } from "./config";
import { http, ApiError, getStoredProfile } from "./apiClient";

const partnerCredentials = () => ({
  client_id: PARTNER.clientId,
  client_secret: PARTNER.clientSecret,
  client_ref_id: PARTNER.clientRefId,
  "x-apigw-api-id": PARTNER.apigwApiId,
});

const resolveCustomerId = () => {
  const stored = getStoredProfile();
  return stored?.customer?.uid || stored?.customerUid || PARTNER.customerIdDefault;
};

const mockQr = (text) =>
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="240" height="240" viewBox="0 0 240 240"><rect width="240" height="240" fill="#fff"/>` +
      Array.from({ length: 144 }, (_, i) => {
        const x = i % 12, y = Math.floor(i / 12);
        const on = (text.charCodeAt(i % text.length) + x * 7 + y * 13) % 3 === 0;
        return on ? `<rect x="${20 + x * 16.6}" y="${20 + y * 16.6}" width="14" height="14" fill="#111"/>` : "";
      }).join("") +
      `<text x="120" y="232" font-size="10" text-anchor="middle" fill="#666">MOCK QR</text></svg>`
  );

export const paymentService = {
  /** สร้าง QR เติมคอยน์ — ได้ { transactionId, refNo, amount, base64, expireDatetime } */
  createQrOrder: async ({ amount, remark = "", packageId }) => {
    const totalAmount = Number(Number(amount).toFixed(2));
    if (!totalAmount || totalAmount <= 0) throw new ApiError("ยอดชำระไม่ถูกต้อง");

    if (IS_MOCK) {
      const id = `mock_${Date.now()}`;
      return { transactionId: id, refNo: id, amount: totalAmount, base64: mockQr(id), expireDatetime: new Date(Date.now() + 600000).toISOString(), mock: true };
    }

    const customerId = resolveCustomerId();
    if (!customerId) throw new ApiError("ไม่พบรหัสลูกค้า กรุณาเข้าสู่ระบบใหม่");
    const orderType = ORDER_TYPE.coinTopup;
    const body = {
      ...partnerCredentials(),
      customer_id: customerId,
      amount: totalAmount,
      ref_no: Date.now().toString(),
      currency: PARTNER.currency,
      order: {
        total_quantity: 1,
        total_price: totalAmount.toFixed(2),
        fee: "0.00",
        order_status: "pending",
        remark,
        process_type: PROCESS_TYPE,
        order_items: [{
          product_type: orderType,
          product_code: packageId || "",
          product_name: remark || "เติมคอยน์",
          product_image: "",
          quantity: 1,
          price: totalAmount,
          total_price: totalAmount,
          order_type: orderType,
          process_type: PROCESS_TYPE,
          remark: JSON.stringify({ packageId, orderType }),
        }],
      },
    };
    const result = await http.post(ENDPOINTS.depositPartner, body);
    if (!result.status) throw new ApiError(result.message, result);
    const gateway = result.data?.data || result.data;
    const gatewayMessage = result.data?.status?.message;
    if (gatewayMessage && gatewayMessage !== "Success") throw new ApiError(gatewayMessage, result);
    if (!gateway?.transaction_id) throw new ApiError("สร้างรายการชำระเงินไม่สำเร็จ", result);
    return {
      transactionId: gateway.transaction_id,
      refNo: gateway.ref_no,
      amount: Number(gateway.amount || totalAmount),
      base64: (gateway.base64 || "").replaceAll("_", "+"),
      orderDatetime: gateway.order_datetime,
      expireDatetime: gateway.expire_datetime,
    };
  },

  getTransaction: async (transactionId) => {
    if (IS_MOCK) return { uid: transactionId, status: (window.__aitalkMockPaid || {})[transactionId] ? "success" : "pending", amount: 0 };
    const result = await http.get(ENDPOINTS.depositGetById, { uid: transactionId });
    if (!result.status) return null;
    const d = result.data;
    return { uid: d.uid, status: d.status, amount: Number(d.amount || 0), refNo: d.ref_no, expiredAt: d.qrs?.expired_at || null };
  },

  inquiry: async (transactionId) => (IS_MOCK ? null : http.get(ENDPOINTS.inquiry, { uid: transactionId })),

  /** mock เท่านั้น */
  mockMarkPaid: (transactionId) => {
    window.__aitalkMockPaid = { ...(window.__aitalkMockPaid || {}), [transactionId]: true };
  },
};
